import { render, staticRenderFns } from "./TemplateStepTermoDeUso.vue?vue&type=template&id=06e61b24&scoped=true"
import script from "./TemplateStepTermoDeUso.vue?vue&type=script&lang=js"
export * from "./TemplateStepTermoDeUso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e61b24",
  null
  
)

export default component.exports